import type {FullExecutorAutoApplicationSetting} from '@rocket-ui/lk-api';
import {isAxiosError} from 'axios';

export type AutoReplyLocation = {
	id: string;
	name: string;
};

export function getAutoReplyCompanyName(setting: FullExecutorAutoApplicationSetting): string {
	return setting.customer?.name?.trim() || 'Без названия';
}

export function normalizeAutoReplyLocations(
	locations?: Array<{id?: string; name?: string}> | null,
): AutoReplyLocation[] {
	return (locations ?? []).flatMap((location) => {
		const id = location.id?.trim();
		const name = location.name?.trim();

		if (!id || !name) {
			return [];
		}

		return [{id, name}];
	});
}

export function formatAutoReplyAddress(locations?: AutoReplyLocation[]): string {
	const names = locations?.map((location) => location.name.trim()).filter(Boolean) ?? [];
	return names.join(', ');
}

export function locationsFromAddressInput(
	address: string,
	original: AutoReplyLocation[] = [],
): Array<{id?: string; name: string}> {
	return address
		.split(',')
		.map((part) => part.trim())
		.filter(Boolean)
		.map((name) => original.find((location) => location.name === name) ?? {name});
}

export function formatAutoReplyPaymentFromRubles(rubles: number): string {
	return `от ${rubles.toLocaleString('ru-RU')} ₽`;
}

export function getAutoReplyApiErrorMessage(error: unknown, fallback: string): string {
	if (isAxiosError<{errors?: string[]; message?: string; detail?: string}>(error)) {
		return (
			error.response?.data?.errors?.[0] ||
			error.response?.data?.message ||
			error.response?.data?.detail ||
			error.message ||
			fallback
		);
	}

	return error instanceof Error ? error.message : fallback;
}
